'use strict';

wbApp.controller('DuePaymentSummaryCtrl', ['$scope', '$translate', '$timeout', 'duePaymentsSvc',
function ($scope, $translate, $timeout, duePaymentsSvc) {

    $scope.filterSummaryDuePaymentsTypes = {
        type: 'PieChart', data: [
            ['Component', 'Value'],
            [$translate.instant('TXT_LAB_COURSE'), 0],
            [$translate.instant('TXT_LAB_ACTION_SINGULAR'), 0],
            [$translate.instant('TXT_LAB_KINDERGARTEN'), 0],
            [$translate.instant('TXT_LAB_RESERVATION'), 0]
        ], options: {
            displayExactValues: true,
            chartArea: { top: '0px', left: '0px', width: '85%', height: '85%' },
            //pieSliceText: 'label',
            legend: { position: 'right' },
        }
    };

    $scope.summaryDuePaymentsTypes = {
        type: 'PieChart', data: [
            ['Component', 'Value'],
            [$translate.instant('TXT_LAB_COURSE'), 0],
            [$translate.instant('TXT_LAB_ACTION_SINGULAR'), 0],
            [$translate.instant('TXT_LAB_KINDERGARTEN'), 0],
            [$translate.instant('TXT_LAB_RESERVATION'), 0]
        ], options: {
            displayExactValues: true,
            chartArea: { top: '0px', left: '0px', width: '85%', height: '85%' },
            //pieSliceText: 'label',
            legend: { position: 'right' },
        }
    };

    var filteredRows = null;
    var isActive = false;
    var loaded = false;

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                onFilterApplied(filteredRows);
            }
        } else {
            isActive = false;
        }
    });

    $scope.$on('filterApplied', function (e, data) {
        // TODO: only when tab is shown       
        filteredRows = data;
        loaded = false;

        if (isActive) {
            onFilterApplied(data);
        }
    });

    var onFilterApplied = function (filteredRows) {
        if (loaded || !filteredRows) {
            return;
        }
        loaded = true;
        $scope.summary = duePaymentsSvc.calculateSummary(filteredRows);
        $timeout(function () {
            $scope.filterSummaryDuePaymentsTypes.data[1][1] = $scope.summary.types[0].value;
            $scope.filterSummaryDuePaymentsTypes.data[2][1] = $scope.summary.types[1].value;
            $scope.filterSummaryDuePaymentsTypes.data[3][1] = $scope.summary.types[2].value;
            $scope.filterSummaryDuePaymentsTypes.data[4][1] = $scope.summary.types[3].value;
        });

        $scope.summaryAll = duePaymentsSvc.calculateSummaryAll();
        $scope.summaryAll.$promise.then(function (data) {
            $timeout(function () {
                $scope.summaryDuePaymentsTypes.data[1][1] = data.types[0].value;
                $scope.summaryDuePaymentsTypes.data[2][1] = data.types[1].value;
                $scope.summaryDuePaymentsTypes.data[3][1] = data.types[2].value;
                $scope.summaryDuePaymentsTypes.data[4][1] = data.types[3].value;
            });
        });
    }

}]);